import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { UpdateDispenserAgreementInfoModalComponent } from './update-dispenser-agreement-info-modal.component'

export const updateDispenserAgreementInfoLayoutConfig: LayoutConfig = {
  launch: {
    UPDATE_DISPENSER_AGREEMENT_INFO: {
      inlineRoot: true,
      component: UpdateDispenserAgreementInfoModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
